import type { FunctionComponent } from "react"

import { CardLayout } from "@/modules/companies/client/components/RecruitmentPatternInformation/CardLayout/CardLayout"
import { Circle } from "@/modules/companies/client/components/RecruitmentPatternInformation/ContractCard/Circle/Circle"
import { useCompanyAnalyticsData } from "@/modules/companies/client/components/RecruitmentPatternInformation/useCompanyAnalyticsData"
import { useCompanyFetch } from "@/modules/companies/client/hooks/useCompanyFetch"
import { useTranslation } from "@/modules/i18n/components/useTranslation"

import styles from "./ContractCard.module.css"

export const ContractCard: FunctionComponent = () => {
  const { dataCompany } = useCompanyFetch()
  const { hasEnoughData, topContract } = useCompanyAnalyticsData()
  const { t } = useTranslation(["companies_client"])

  if (!dataCompany) return null
  if (!hasEnoughData || !topContract) return null

  const maxPercent = topContract.contracts[0].percent

  return (
    <CardLayout
      title={t("companies_client.recruitmentPatternInformation.contract.title", {
        name: dataCompany.page.name,
        totalPositions: topContract.totalPositions,
      })}
      data-testid="recruitementPattern_contract"
    >
      <ul className={styles.wrapper}>
        {topContract.contracts.map(contract => {
          return (
            <Circle
              key={contract.name}
              percent={contract.displayPercent}
              name={contract.name}
              globalYDelta={(100 - maxPercent) / 2}
              globalXDelta={maxPercent / 2}
            />
          )
        })}
      </ul>
      <ul aria-hidden="true" className={styles.legend}>
        {topContract.contracts.map(contract => {
          return (
            <li key={contract.name} className={styles.item}>
              {contract.name}
            </li>
          )
        })}
      </ul>
    </CardLayout>
  )
}
